import {useState,useEffect,useRef} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "./customHooks/authContext";
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import {Button} from "@progress/kendo-react-buttons";
import {ColumnMenu} from "./columnMenu";
import { getReferrals,approveReferrals,deleteReferrals } from "./services/referralsService";
import { process } from '@progress/kendo-data-query';
import {loadingPanel} from "./styles/loadingPanel";
import "./styles/referralList.css"
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

const ReferralsList = () =>{
    const auth = useAuth();
    const navigate = useNavigate();
    const [loading,setLoading] = useState(true);
    const [referrals,setReferrals] = useState(null);
    const totalRecords = useRef(0);
    const [pageData,setPageData] = useState([{}]);
    const [showDialog, setShowDialog] = useState(false);
    const [dataState,setDataState] = useState( ()=> {
        if (auth.user.flag_can_approve_referral === "True"){ return {
        skip:0,take:10
    //     ,filter:
    //     {logic:"and"
    //     ,filters:[
    //         {field:"dealer_Id"
    //         ,operator:"eq"
    //         ,value:"1"      
    //         }   
    // ]}
        
        // ,sort: [
        //     { field: 'approved_By_Advisor_Id', dir: 'asc' }
        //     ,{ field: 'created_Date', dir: 'desc' }
        // ]
        // ,group: [
        //     // { field: 'customerID' }
        // ]
        }
    }
    else return {
        skip:0,take:10   
        ,sort: [
            { field: 'created_Date', dir: 'desc' }
        ]        
        }
        });
        const getReferralsData = async () =>{
            debugger;
            let ref = await getReferrals(auth.user.AdvisorId,auth.user.token,auth.user.loginId);            
            ref = ref.map(dataItem => {
                console.log('',!(dataItem.approved_By_Advisor_Id && dataItem.approved_By_Advisor_Id > 0));
                // if (!(dataItem.approved_By_Advisor_Id && dataItem.approved_By_Advisor_Id > 0))
                //     return Object.assign({ selected: false,approved: 'No', deleted: 'No',lodge_Date: dateChange(dataItem.created_Date),approval_Date: dateChange(dataItem.approved_Date) }, dataItem)
                
                    if (dataItem.approved_By_Advisor_Id && dataItem.approved_By_Advisor_Id > 0)
                        return Object.assign({ status: 'Approved', deleted: 'No', lodge_Date: dateChange(dataItem.created_Date),action_Date: dateChange(dataItem.approved_Date)  }, dataItem);
                    else if (dataItem.deleted_By_Advisor_Id && dataItem.deleted_By_Advisor_Id > 0)
                        return Object.assign({ status: 'Deleted', deleted: 'Yes', lodge_Date: dateChange(dataItem.created_Date),action_Date: dateChange(dataItem.deletion_Date)  }, dataItem);
                    else
                        return Object.assign({selected: false, status: 'Not Actioned', deleted: 'No',lodge_Date: dateChange(dataItem.created_Date),action_Date: dateChange(dataItem.approved_Date)  }, dataItem);
                
            }
                );
            setReferrals((old) => { 
                              
                setPageData( oldPage => { const newPage = process(ref, dataState); return {...oldPage,...newPage} } ); 
                totalRecords.current = ref.length;
                //setPageData(process(ref, dataState));
                //const p = [...ref];
                //setPageData(p.slice(dataState.skip,dataState.skip + dataState.take));        
                return ref;
                //return ({...old,...ref});
            }
                );
            
            setLoading(false);
            
            }
    useEffect( () => {
        

        getReferralsData();
    },[])

    useEffect( () => {       

        //console.log("Referrals Data Changed");
    },[referrals])
    const dataStateChange = (e) =>{
       // debugger;
        setLoading(true);
        
            setPageData((oldPage) => { 
            const newPage = process(referrals, e.dataState); 
            totalRecords.current = newPage.length;
            //console.log(d);
            return {...oldPage,...newPage};});
            
        setDataState(e.dataState);
        setLoading(false);
        
        
    }

    const selectionChange = (e) =>{
        //console.log(pageData);
        const updatedData = pageData.data.map( item => {
            if (item.dealer_Id === e.dataItem.dealer_Id){
                item.selected = !e.dataItem.selected;
            }
            return item;
        })
        setPageData((old) => {return {...old,data:updatedData,total:pageData.total}} );
    }

    function dateChange(st){
        console.log(st);
        if (st == '0001-01-01T00:00:00')
            return null;
        else{
        var dateParts = st.split('T')[0].split('-');
        var year = parseInt(dateParts[0]);
        // Months are 0-based in JavaScript
        var month = parseInt(dateParts[1]) - 1; 
        var day = parseInt(dateParts[2]);      

        return (new Date(year, month, day)).toLocaleDateString('en-GB');
        }
    }

    const headerSelectionChange = (event) => {
        const checked = event.syntheticEvent.target.checked;
        const updatedData = pageData.data.map(item=>{
            if (item.hasOwnProperty("selected")){
                item.selected = checked;
                return item;
            }
            return item;
        });
        setPageData((old) => {return {...old,data:updatedData,total:pageData.total}} );
    }

    const handleCheck = (e,id) =>{
        
         const checked = e.target.checked;
        const updatedData = pageData.data.map(item=>{
            if (item.id === id)
                item.selected = checked;
            return item;
        });
        setPageData((old) => {return {...old,data:updatedData,total:pageData.total}} );
    }
    const changeSelectionOption = (props) =>{
        if ((props.dataItem.approved_By_Advisor_Id && props.dataItem.approved_By_Advisor_Id > 0) || (props.dataItem.deleted_By_Advisor_Id && props.dataItem.deleted_By_Advisor_Id > 0))
        {
            return (<td></td>);
        }
        else
        {
            return( <td>
                <input type="checkbox" defaultChecked={props.dataItem.selected} onChange={ (e) => handleCheck(e,props.dataItem.id)}></input>
            </td> );
            
        }
    }
    const showApprovalStatus = (props) =>{
        if (props.dataItem.approved_By_Advisor_Id && props.dataItem.approved_By_Advisor_Id > 0)
        {
            return (<td
                colSpan={props.colSpan}
                role={'gridcell'}
                aria-colindex={11}
                aria-selected={false}
                // {...{
                //   [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
                // }}
                // {...navigationAttributes}
            >Yes</td>);
        }
        else
        {
            return( <td 
                colSpan={props.colSpan}
                role={'gridcell'}
                aria-colindex={11}
                aria-selected={false}
                // {...{
                //   [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
                // }}
                // {...navigationAttributes}
                >
                No
            </td> );
            
        }
    }
const rowClick = (e) =>{
    //debugger;
    navigate(`/referrals/${e.dataItem.id}`);
}
    const handleApproveReferrals = (e) =>{
        const list =[];
        referrals.map(r => {if (r.selected) list.push(r.id);} );
        const callApproveReferrals = async()=>{
             await approveReferrals(auth.user.AdvisorId,auth.user.token,list,auth.user.loginId);
        }
        
        callApproveReferrals();
        //debugger;
        setLoading(true);
        setTimeout(()=>{
            getReferralsData();
        },1000)
    }

    const showDeletionDialog = () => {
        // const list =[];
        // referrals.map(r => {if (r.selected) list.push(r.id);} );
        // if (list.length > 0)
        setShowDialog(true);
    }
    const handleDeleteReferrals = () =>{
        const list =[];
        referrals.map(r => {if (r.selected) list.push(r.id);} );
        const callDeleteReferrals = async()=>{
             await deleteReferrals(auth.user.AdvisorId,auth.user.token,list,auth.user.loginId);
        }
        
        callDeleteReferrals();
        //debugger;
        setLoading(true);
        setTimeout(()=>{
            getReferralsData();
            setShowDialog(false);
        },1000)
        
    }
    // const filterChange = (e) => {
    //     debugger;
    //     if (e.syntheticEvent.type === "click"){
    //         const ds = {
    //             filter: e.filter
    //             //,group: undefined
    //             ,skip: 0
    //             ,sort: dataState.sort
    //             ,take: dataState.take
    //         }
    //         setPageData((oldPage) => { const newPage = process(referrals, ds); 
    //             //console.log(d);
    //             return {...oldPage,...newPage};});
                
    //         setDataState(ds);
    //     }
        
    // }

    // const pageChange = (e) => {
    //     const p = [...referrals];
    //     setPageData(p.slice(e.page.skip,e.page.skip + e.page.take));
    //     setDataState({skip:e.page.skip,take:e.page.take})
    // }

    
    return(
        <div className="referralListContainer">
        
        {/* {loading && <Loader style={{position:"absolute", top: "50%",left:"50%"}} size='large' type="pulsing" />} */}
        {loading && loadingPanel}
        {/* {!loading && <h1>{console.log(referrals.length)}</h1>} */}
        <Grid
            data={pageData}{...dataState}
            scrollable="none"
            skip={dataState.skip}
            take={dataState.take}
            pageSize={10}
            total={totalRecords.current}
            //sortable={true}
            filterable={true}
            //groupable={true}
            reorderable={true}
            //pageable={{ buttonCount: 4,  }}
            pageable={{pageSizes: true}}
            //onPageChange={pageChange}
            onDataStateChange={dataStateChange}
            selectedField="selected"
            onSelectionChange={selectionChange}
            onHeaderSelectionChange={headerSelectionChange}            
            onRowDoubleClick={rowClick}
            //onFilterChange={filterChange}   
                     
        >
            {auth.user.flag_can_approve_referral === "True" && <GridColumn field="selected" title="Select" filterable={false} cell={changeSelectionOption}></GridColumn>}
            {/* filterable={true} filter={'boolean'} */}
            {/* <GridColumn field="dealer_Id" filter={'numeric'} /> */}
            <GridColumn field="dealer_Name" title="Dealer Name" filterable={true}  />
            {/* columnMenu={ColumnMenu }*/}
            <GridColumn field="salesperson_Name" title="Sales Person" filterable={true} />
            <GridColumn field="giftcard_Value"  title="Gift Card" filterable={false} />
            <GridColumn field="purchase_Order_Num" title="Purchase Order" filterable={true} />
            <GridColumn field="membership_Num" title="Membership No" filterable={true} />
            <GridColumn field="cust_Name" title="Membership Name" filterable={true} />
            <GridColumn field="cust_Email" title="Email" filterable={true} />
            <GridColumn field="cust_Mobile_No" title="Mobile" filterable={true} />
            <GridColumn field="stock_No" title="Stock No" filterable={true} />
            <GridColumn field="lodge_Date" title="Date" filterable={false}  />
            <GridColumn field="status" title="Status" filterable={true}  />
            {/* <GridColumn field="deleted" title="Deleted" filterable={true}  /> */}
            <GridColumn field="action_Date" title="Action Date" filterable={false}  />
            {/* <GridColumn field="approved_By_Advisor_Name" title="Approved By" filterable={true} /> */}
        </Grid>
        
        <br/>
        {auth.user.flag_can_approve_referral === "True" && <div><Button primary={true}  onClick={(e) => handleApproveReferrals(e)} style={{marginLeft:"10px"}}>Approve Referral</Button> <Button primary={true}  onClick={showDeletionDialog} style={{marginLeft:"10px"}}>Delete Referral</Button></div>}
        


        {showDialog && 
            <Dialog title={"Alert"} 
                onClose={()=>setShowDialog(false)} 
                      >
                          <p>The selected record(s) will be deleted. Are you sure you want to continue?&nbsp;&nbsp;&nbsp;</p>
                          
                           <DialogActionsBar>
                               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                               
                  <Button primary={true} onClick={handleDeleteReferrals}>Yes</Button>
                 &nbsp;&nbsp;&nbsp;&nbsp;
                  <Button onClick={()=>setShowDialog(false)} >No</Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  
                  
                  
                </DialogActionsBar> 
                <DialogActionsBar>&nbsp;</DialogActionsBar>
            </Dialog>
        } 
        </div>
    );
}

export default ReferralsList;